import React from "react"
import { ResponsivePie } from "@nivo/pie"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"
import { CHART_COLORS, NIVO_THEME } from "@react/projects/chantiers_dashboard/components/palette"

const BreakdownPie = ({ icon, title, subtitle, data, currency, max = 8 }) => {
  const rows = (data || []).slice(0, max).map((row, index) => ({
    id: row.id, label: row.label, value: row.value / 100,
    count: row.count, color: CHART_COLORS[index % CHART_COLORS.length],
  }))
  const money = (value) =>
    new Intl.NumberFormat(I18n.locale || "fr", {
      style: "currency", currency: currency || "EUR", maximumFractionDigits: 0,
    }).format(value)

  return (
    <ChartCard icon={icon} title={title} subtitle={subtitle} height={280}
               empty={rows.length === 0 ? I18n.t("contracts_dashboard.charts.empty") : null}>
      <ResponsivePie
        data              = {rows}
        margin            = {{ top: 16, right: 16, bottom: 16, left: 16 }}
        innerRadius       = {0.62}
        padAngle          = {1.2}
        cornerRadius      = {3}
        colors            = {{ datum: "data.color" }}
        borderWidth       = {0}
        enableArcLinkLabels = {false}
        arcLabelsSkipAngle  = {22}
        arcLabelsTextColor  = "#fff"
        arcLabel          = {(d) => d.data.count}
        theme             = {NIVO_THEME}
        tooltip           = {({ datum }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "7px 11px", fontSize: 11, borderRadius: 6 }}>
            <strong>{datum.data.label}</strong> · {money(datum.value)}
            <div style={{ opacity: 0.75 }}>
              {I18n.t("contracts_dashboard.charts.contracts_count", { count: datum.data.count })}
            </div>
          </div>
        )}
      />
    </ChartCard>
  )
}

export default BreakdownPie
